import { gql } from "@apollo/client";

export const HEADER_QUERY = gql`query Headers
  {
    header {
        menus {
            label,
            link,
            children {
                label,
                link,
                children {
                label,
                link
              }
            }
        }
    }
  }`